import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../index';
import { mapOperations } from '../redux/map';
import { authOperations } from '../redux/auth';
import { filterOperations } from '../redux/filter';
import { userOperations } from '../redux/user';
import { customFilterOperations } from '../redux/customFilter';
import { configOperations } from '../redux/config';
import { incidentsOperations } from '../redux/incidentList';
import { Alert } from '@mui/material';

import Header from './Header';
import Report from './report/Report';
import Map from './esri/Map';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IncidentDiscovery from './incidentDiscovery';
import IncidentDetails from './incidentDetails';
import NewIncident from './newIncident';
import Reporting from './reporting';
import Print from './reporting/print';
import Dictionary from './dictionary';
import * as JsDiff from 'diff';

import {
  getOriginLayerFieldInfos,
  getOriginLayerFeatures,
  onOriginLayerUpdateEnd,
  setOriginLayerDefinitionExpression, onMapExtentChanged, setCustomFilterDefinitionExpression, addAndSaveUserLayer, removeUserLayer
} from './esri/mapHub';
import UserInfoDialog from './user/UserInfoDialog';
import UserLayerDialog from './user/UserLayerDialog';


class Main extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      showUserLayerDialog: false
    }
  }

  componentDidMount() {
    window.api.setAuth(this.props.auth.user);
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.filter) === JSON.stringify(this.props.filter)) {
      return;
    }

    let filterDiffs = JsDiff.diffWords(JSON.stringify(prevProps.filter), JSON.stringify(this.props.filter));
    //Dont refresh map if the only thing happening is we're not loading anymore
    if (filterDiffs.length === 4 && filterDiffs[0].value.replace(/"/g, '').endsWith("loading:")) {
      return;
    }

    //Dont refresh map if the only thing happening is we're not using basic filter anymore
    if (filterDiffs.length === 4 && filterDiffs[0].value.replace(/"/g, '').endsWith("isBasicFilterActive:")) {
      return;
    }

    //Don't refresh map if we're just changing selected incidents
    if (filterDiffs.length === 4 && filterDiffs[0].value.replace(/"/g, '').endsWith("uniqueFireIds:[")) {
      return;
    }


    this.filterMap();
  }

  onMapLoaded = () => {

    getOriginLayerFieldInfos().then(fields => {
      //set the fields to the redux store
      this.props.setOriginFieldInfos(fields);
    });


    this.startWatchingPointOfOriginUpdates();
    this.startWatchingExtent();

    this.props.mapLoaded();
  }

  onMapLoadError = () => 
  {
    this.setState({ showError: true });
  }

  filterMap = () => {

    if (this.props.filter.mapDrawingPaused) {
      return;
    }
    
    if (this.props.filter.isBasicFilterActive) 
    {
      this.props.setFilterLoading(true);
        
      setOriginLayerDefinitionExpression(this.props.filter).then( response => {
        this.props.setQueriedIncidentsTotal(response.total);
        this.props.setDisplayedIncidentsCount(response.features.length);
        this.props.setIncidents(response.features);
        this.props.setVisibleIncidents(response.features);
        this.props.setFilterLoading(false);
      });
      this.props.setBasicFilterActive(true);
    }
    else 
    {
      this.props.setFilterLoading(true);
      setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => {
        this.props.setQueriedIncidentsTotal(response.total);
        this.props.setDisplayedIncidentsCount(response.features.length);
        this.props.setIncidents(response.features);
        this.props.setVisibleIncidents(response.features);
        this.props.setFilterLoading(false);
      });
    }
  }

  startWatchingPointOfOriginUpdates() {
    if (!this.handlePointOfOriginUpdates) {
      // const originLayerName = this.props.appConfig.originLayer.layerName;
      onOriginLayerUpdateEnd(this.onPointOfOriginUpdated);
    }
  }

  stopWatchingPointOfOriginUpdates() {
    if (this.handlePointOfOriginUpdates) {
      this.handlePointOfOriginUpdates.remove();
      delete this.handlePointOfOriginUpdates;
    }
  }

  onPointOfOriginUpdated = (args, handle) => {
    this.handlePointOfOriginUpdates = handle;
    this.props.setFilterLoading(args.updating);
    if (args.updating) {
      this.stopWatchingExtent();
    }
    else {
      //this.props.setIncidents(args.graphics);
      //this.props.setVisibleIncidents(args.visibleGraphics);
      this.startWatchingExtent();
    }
  }

  startWatchingExtent() {
    if (!this.extentHandle) {
      onMapExtentChanged((extent) => {
        this.onExtentChanged(extent);
        //this.extentHandle = handle;
      });
    }
  }

  stopWatchingExtent() {
    //if (this.extentHandle) {
    //    this.extentHandle.remove();
    //  delete this.extentHandle;
    //    }
  }

  onExtentChanged = (extent) => {
    getOriginLayerFeatures(extent).then(
      results => {
        //this.props.setVisibleIncidents(results.graphics);
      }
    );
  }

  onUserInfoSave = (userSession) => {
    window.api.saveUserInfo(userSession).then(
      results => {
        this.props.setUpdatePrompt(false);
      }
    );
  }

  onUserLayerSave = (title, url, showDefault, popups) => 
  {
    addAndSaveUserLayer(
    {
      Title: title,
      Url: url,
      ShowDefault: showDefault, 
      ShowPopups: popups
    });

    this.setState({ showUserLayerDialog: false });
  }

  onUserLayerRemove = (item) =>  
  {
    removeUserLayer(item);
  }

  onUserLayerAdd = () => {
    this.setState({ showUserLayerDialog: true });
  }

  onUserLayerDialogClose = () => 
  {
    this.setState({ showUserLayerDialog: false });
  }

  onUserInfoClose = () => 
  {
    this.props.setUpdatePrompt(false);
  }

  handleMapIncidentSelection = (forId) => {
    if (forId) 
    {
      history.push('/incidents/' + forId);
    }
  }

  handlePerimeterAddIrwinId = (incident) => 
  {
    this.props.setAddIrwinIdToPerimeter(incident);
  }

  render() {

    const errorBlock = (this.props.auth.hasNoRoles) ?
      (<Dialog open={true}>Your account doesn't appear to have any roles assigned to it for InFORM. <br /><br /><a href="https://survey123.arcgis.com/share/fa79f92cbe1d465f9c3414301cb09968" target="_new">Please request an access role here</a><br /><br />Or you can sign out and log back in with a different NIFC Org account
        <FlatButton
          label="Sign out"
          primary={true}
          onClick={this.props.logout}
        />
      </Dialog>)
      : (<Dialog open={true}><b>Error:</b> Inspector was unable to load the Incidents layer and cannot proceed. <p>This typically occurs when the map services are unavailable or offline.</p><p>You may try reloading your browser.</p></Dialog>)
    return (this.state.showError) ? (errorBlock) :
      (
        <div className={'App' + (this.props.filter.visible ? " filter-visible " : " filter-hidden ") + (this.props.incidentList.visible ? "incident-list-visible" : "incident-list-hidden")}>
          <Switch>
            <Route path='/incidents/:incidentId/report' render={() => ("")} exact />
            <Route path='/' component={Header} />
          </Switch>
          <div className='app-content'>
            <Route exact path="/" render={() => (<Redirect to={`/incidents`} />)} />
            <Route exact path="/incidents" component={IncidentDiscovery} />
            <Route exact path="/reporting" component={Reporting} />
            <Route exact path="/reporting/print" component={Print} />
            <Route exact path="/dictionary" component={Dictionary} />
            <Route exact path="/reportIncident" component={NewIncident} />
            <Route exact path="/incidents/:incidentId" component={IncidentDetails} />
            <Route exact path="/incidents/:incidentId/report" component={Report} />
            <div className='map-container'>
              <div id="editPerimeterAnchorEl"></div>
              <div id="measurementTopbar"><button
                className="action-button esri-icon-measure-line"
                id="distanceButton"
                type="button"
                title="Measure distance between two or more points">
              </button>
                <button
                  className="action-button esri-icon-measure-area"
                  id="areaButton"
                  type="button"
                  title="Measure area">
                </button>
                <button id="clearButton" type="button" className="action-button esri-icon-trash" title="Clear Measurements"></button>
              </div>
              <Map
                appConfig={this.props.appConfig}
                mapState={this.props.map}
                user={this.props.auth.user}
                isReadOnly={this.props.auth.isReadOnly}
                filter={this.props.filter}
                customFilter={this.props.customFilter}
                onUserLayerAdd={this.onUserLayerAdd}
                onUserLayerRemove={this.onUserLayerRemove}
                onMapLoaded={this.onMapLoaded}
                onMapLoadError={this.onMapLoadError}
                onIncidentSelection={this.handleMapIncidentSelection}
                onPerimeterAddIrwinId={this.handlePerimeterAddIrwinId}
                updateExtent={this.props.setExtent}
              />
              <UserInfoDialog 
              onSave={this.onUserInfoSave}
              userSession={this.props.auth.userSession}
              onClose={this.onUserInfoClose}
              open={this.props.auth.shouldPromptForUserUpdate} />
             
             <UserLayerDialog 
              onSave={this.onUserLayerSave}
              onClose={this.onUserLayerDialogClose}
              open={this.state.showUserLayerDialog} />
              <div id="updatePerimeterDiv" className="esri-widget esri-hidden">
                <div id="updateNifsPerimeterForm" className="scroller esri-component perimeter-panel-container">
                  <input
                    type="button"
                    className="esri-button"
                    value="Update Irwin ID - NIFS"
                    id="btnUpdateNifsPerimeter"
                  />
                  <div role="button" tabIndex="0" className="esri-popup__button perimeter-close-button" id="btnCloseUpdateNifsPerimeter" aria-label="Close" title="Close">
                    <span aria-hidden="true" className="esri-popup__icon esri-icon-close perimeter-close-button"></span>
                  </div>
                </div>
                <div id="updateFireHistoryPerimeterForm" className="scroller esri-component perimeter-panel-container">
                  <input
                    type="button"
                    className="esri-button"
                    value="Update Irwin ID - FireHistory"
                    id="btnUpdateFireHistoryPerimeter"
                  />
                  <div role="button" tabIndex="0" className="esri-popup__button perimeter-close-button" id="btnCloseUpdateFireHistoryPerimeter" aria-label="Close" title="Close">
                    <span aria-hidden="true" className="esri-popup__icon esri-icon-close perimeter-close-button"></span>
                  </div>
                </div>
              </div>
              <Alert id="pauseIncidentDrawAlert" severity="error" className="esri-widget esri-hidden">Map Drawing is Paused.</Alert>
              <div id="basemapGalleryContainer" className="esri-widget esri-icon-down esri-hidden">
                <div id="basemapGalleryDiv" style={{ width: '300px !important' }}>
                  <div role="button" tabIndex="0" className="esri-popup__button perimeter-close-button" id="btnToggleBasemapGallery">
                    <span aria-hidden="false" className="esri-popup__icon esri-icon-down"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config,
  filter: state.filter,
  customFilter: state.customFilter,
  incidentList: state.incidentList,
  user: state.user
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...mapOperations,
    ...authOperations,
    ...configOperations,
    ...filterOperations,
    ...customFilterOperations,
    ...incidentsOperations,
    ...userOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
